module.exports = __webpack_public_path__ + "img/3.3336108e.png";